import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const documentDiscussionsService = { get, add, del, newCountGet, markAsRead };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'DocumentDiscussions'
};

function extract(r) {
  return r.data;
}

async function get(documentVersionCode) {
  return axios.get(`${model.baseUrl}${model.controller}/get?documentVersionCode=${documentVersionCode}`).then(extract);
}

async function add(documentVersionCode: string, comment: string) {
  return axios.put(`${model.baseUrl}${model.controller}/add/${documentVersionCode}`, { comment }).then(extract);
}

async function del(documentDiscussionId: number) {
  return axios.delete(`${model.baseUrl}${model.controller}/del/${documentDiscussionId}`).then(extract);
}

async function newCountGet(documentVersionCode) {
  return axios.get(`${model.baseUrl}${model.controller}/NewCountGet?documentVersionCode=${documentVersionCode}`).then(extract);
}

async function markAsRead(documentVersionCode: string) {
  return axios.put(`${model.baseUrl}${model.controller}/MarkAsRead/${documentVersionCode}`).then(extract);
}
